import { useEffect } from 'react'
import { useAuth } from '@clerk/react'
import { forgetStaffConversation } from '@/lib/conversation'

/**
 * SIGNED OUT, ON ANY PAGE, MEANS NO CONVERSATION IN MEMORY (batch 2v).
 *
 * Mounted once, inside the staff surface's ClerkProvider and beside its
 * routes, so it runs whichever page the account button was pressed on. Had it
 * lived in the chat page, signing out from Questions would have left the last
 * person's conversation in memory until the chat next opened. It would never
 * have been drawn for someone else (the store is keyed to the person), but
 * memory that holds nobody's conversation is the stronger guarantee, and it
 * costs nothing.
 *
 * Draws nothing.
 */
export default function StaffConversationGuard() {
  const { isLoaded, userId } = useAuth()
  useEffect(() => {
    if (isLoaded && !userId) forgetStaffConversation()
  }, [isLoaded, userId])
  return null
}
